import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

const AccessDenied = ({ message }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "45vh",
        p: 3,
        textAlign: "center",
        gap: 2,
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 700, color: "error.main" }}>
        Access Denied
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 520 }}>
        {message || "Your account does not have permission to view this page."}
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate("/main/dashboard", { replace: true })}
        sx={{
          borderRadius: 2,
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Go to Dashboard
      </Button>
    </Box>
  );
};

export default AccessDenied;

